import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ManageMTC.css";
import ValveMTCForm from "./ValveMTCForm";

const valveTypes = [
  { id: "gate", name: "Gate" },
  { id: "globe", name: "Globe" },
  { id: "ball", name: "Ball" },
  { id: "check", name: "Check" },
  { id: "lsb", name: "LSB" },
  { id: "actuator", name: "Actuator" },
  { id: "automation", name: "Automation" },
];

// All valve types supported by ValveMTCForm
const supportedValves = ["gate", "globe", "ball", "check", "lsb", "actuator", "automation"];

function ManageMTC() {
  const navigate = useNavigate();
  const [activeValve, setActiveValve] = useState(null);

  const handleCardClick = (valveId) => {
    setActiveValve(valveId);
  };

  const handleBack = () => {
    setActiveValve(null);
  };

  // If valve is supported by ValveMTCForm, show the form
  if (supportedValves.includes(activeValve)) {
    return <ValveMTCForm valveType={activeValve} onBack={handleBack} />;
  }

  // Placeholder for other valve types (if any)
  if (activeValve) {
    return (
      <div className="mtc-container">
        <button className="mtc-back-button" onClick={handleBack}>
          ← Back to MTC
        </button>
        
        <div className="mtc-header">
          <h1 className="mtc-title">
            {valveTypes.find(v => v.id === activeValve)?.name} Valve MTC
          </h1>
          <p className="mtc-subtitle">
            This valve type is coming soon
          </p>
        </div>

        <div className="coming-soon-message">
          <p>The MTC form for {valveTypes.find(v => v.id === activeValve)?.name} valve is under development.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mtc-container">
      <button className="mtc-back-button" onClick={() => navigate("/dashboard")}>
        ← Back to Dashboard
      </button>

      <div className="mtc-header">
        <h1 className="mtc-title">Manage MTC</h1>
        <p className="mtc-subtitle">
          Select the type of MTC to create certificate
        </p>
      </div>

      <div className="mtc-type-selection">
        <div className="mtc-type-cards">
          {valveTypes.map((valve) => (
            <div
              key={valve.id}
              className="mtc-type-card"
              onClick={() => handleCardClick(valve.id)}
            >
              <div className="mtc-card-content">
                <h3 className="mtc-card-title">{valve.name}</h3>
                <span className="mtc-card-badge">MTC</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ManageMTC;
